import { Component, Input } from '@angular/core';

@Component({
  selector: 'ngx-not-found',
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
  @Input() message: string = 'No data found.';
}
